import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Report from '../../components/report';

export default class CampaignDashboard extends Component {
  constructor() {
    super();
    this.state = {};
  }


  render() {
    const { params: { id: campaignId } } = this.props;
    return (
      <Report {...this.props} id={campaignId} />
    );
  }
}

CampaignDashboard.propTypes = {
  params: PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard/index.js
 **/